import React from "react";
import { useEntityDetail } from "../../hooks/useEntityDetail";
import type { EntityDetailProps } from "../../types/entityRegistry";
import EntityDetailContent from "./EntityDetailContent";

/**
 * The detail of an organization, facility, project or source.
 * These four share one fetch and one body layout; which of them an id names
 * is told from the response, so the same component serves all four entries
 * of the registry and an id that comes without a type.
 */
const GraphEntityDetail: React.FC<EntityDetailProps> = ({
  entityId,
  mode = "overlay",
  onEntityClick,
  onClose,
  scrollContainerRef,
}) => {
  const { entityDetailResponse, mainEntity, loading, error } = useEntityDetail(
    entityId || null,
  );

  // Not-found states: a fetch that settled without a usable entity
  let notFound: string | null = null;
  if (entityId && !loading && !error) {
    if (!entityDetailResponse) {
      notFound = "No data found for this entity";
    } else if (!mainEntity) {
      notFound = "Invalid entity data received";
    }
  }

  return (
    <EntityDetailContent
      entityDetailResponse={entityDetailResponse}
      mainEntity={mainEntity}
      loading={loading}
      error={error || notFound}
      onEntityClick={onEntityClick}
      onClose={onClose}
      mode={mode}
      scrollContainerRef={scrollContainerRef}
    />
  );
};

export default GraphEntityDetail;
